import { apiClient } from './api';

export const systemFeatureService = {
  getAllFeatures: () => {
    return apiClient.get('/system-features');
  },

  saveFeatures: (data) => {
    return apiClient.put('/system-features', data);
  },
};
